import { Component, Input } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { VerificationHeadingComponent } from '../verification-heading/verification-heading.component';
import { SpecialistEncounterFormComponent } from '../specialist-encounter-form/specialist-encounter-form.component';

@Component({
    selector: 'app-validate-specialist-encounter',
    templateUrl: './validate-specialist-encounter.component.html',
    styleUrls: ['./validate-specialist-encounter.component.scss'],
    imports: [VerificationHeadingComponent, SpecialistEncounterFormComponent]
})
export class ValidateSpecialistEncounterComponent {
  constructor() {}

  @Input() capture: Capture;
  @Input() patientAttachment: PatientAttachment;
}
